import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgInfo16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1ZM7.29199 6.24219V11.333H8.7041V6.24219H7.29199ZM8.00098 4.15723C7.79118 4.15729 7.61113 4.22876 7.46094 4.37012C7.31306 4.50925 7.2393 4.67582 7.23926 4.87012C7.23926 5.06667 7.31305 5.23559 7.46094 5.37695C7.61113 5.5161 7.79118 5.58588 8.00098 5.58594C8.21089 5.58594 8.39004 5.51616 8.53809 5.37695C8.68823 5.23557 8.76367 5.0667 8.76367 4.87012C8.76363 4.67579 8.68822 4.50927 8.53809 4.37012C8.39004 4.2287 8.21089 4.15723 8.00098 4.15723Z",
    fill: "#333333"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfo16);

export { ForwardRef as ReactComponent };
//# sourceMappingURL=Info16.svg.js.map
